export default __webpack_public_path__ + "static/media/courseOfflineIcon.36d91e3b.svg";